const priorityConfig = {
  "P1": { bg: "#D1FAE5", text: "#059669", border: "#A7F3D0", label: "P1", desc: "30 days" },
  "P2": { bg: "#DBEAFE", text: "#2563EB", border: "#BFDBFE", label: "P2", desc: "20 days" },
  "P3": { bg: "#FEF3C7", text: "#D97706", border: "#FDE68A", label: "P3", desc: "48 hours" },
  "P4": { bg: "#FFEDD5", text: "#EA580C", border: "#FED7AA", label: "P4", desc: "24 hours" },
  "P5": { bg: "#FEE2E2", text: "#DC2626", border: "#FECACA", label: "P5", desc: "4 hours" },
};

const PriorityBadge = ({ priority, showDesc = false }) => {
  const config = priorityConfig[priority] || priorityConfig["P3"];

  return (
    <span
      className="inline-flex items-center gap-1.5 px-2.5 py-1 rounded-sm text-xs font-bold border"
      style={{
        backgroundColor: config.bg,
        color: config.text,
        borderColor: config.border,
      }}
      data-testid={`priority-badge-${priority}`}
    >
      <span className="w-1.5 h-1.5 rounded-full" style={{ backgroundColor: config.text }} />
      {config.label}
      {showDesc && <span className="font-normal opacity-80">({config.desc})</span>}
    </span>
  );
};

export default PriorityBadge;
